import React, { useState } from 'react';
import SeoHead from '../../../shared/seo/SeoHead';
import { FauxFurPomPomSeo } from '../../pompom/seo/FauxFurPomPomSeo';
import '../../pompom/styles/fauxFurPomPomStyle.css';

const HERO_STATS = [
    { value: '200+', label: 'Colors' },
    { value: '50+', label: 'Countries' },
    { value: '20cm', label: 'Max Size' },
    { value: '100%', label: 'Cruelty Free' },
];






const FauxFurPomPomsPage: React.FC = () => {

    const [activeCategory, setActiveCategory] = useState('All');

    const selectCat = (cat: string) => {
        setActiveCategory(cat);
    };

    return (
        <div className="ffp-page">

            <SeoHead {...FauxFurPomPomSeo} />

            {/* JSON-LD FAQPage schema */}
       

            {/* Breadcrumb */}
            <nav aria-label="Breadcrumb" className="ffpf-breadcrumb-nav">
                <ol
                    className="ffpf-breadcrumb"
                    itemScope
                    itemType="https://schema.org/BreadcrumbList"
                >
                    <li
                        itemProp="itemListElement"
                        itemScope
                        itemType="https://schema.org/ListItem"
                    >
                        <a href="/" itemProp="item">
                            <span itemProp="name">Home</span>
                        </a>
                        <meta itemProp="position" content="1" />
                    </li>

                    <li>
                        <span className="ffpf-bsep" aria-hidden="true">
                            ›
                        </span>
                    </li>

                    <li
                        itemProp="itemListElement"
                        itemScope
                        itemType="https://schema.org/ListItem"
                    >
                        <a href="/faux-fur-pom-poms" itemProp="item">
                            <span itemProp="name">Faux Fur Pom Poms</span>
                        </a>
                        <meta itemProp="position" content="2" />
                    </li>

                    <li>
                        <span className="ffpf-bsep" aria-hidden="true">
                            ›
                        </span>
                    </li>

                    <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <a href="/faux-fur-pom-poms-faq" itemProp="item"><span itemProp="name">FAQ</span></a>
                        <meta itemProp="position" content="2" />
                    </li>
                </ol>
            </nav>

            {/* Hero */}
            <section className="ffpf-hero">

                <div className="ffpf-hero-bg" aria-hidden="true" />
                <div className="ffpf-blob ffpf-blob--1" aria-hidden="true" />
                <div className="ffpf-blob ffpf-blob--2" aria-hidden="true" />
                <div className="ffpf-blob ffpf-blob--3" aria-hidden="true" />

                <div className="ffpf-hero-dots" aria-hidden="true">
                    {Array.from({ length: 30 }).map((_, i) => (
                        <span key={i} />
                    ))}
                </div>

                <div className="ffpf-hero-inner">

                  

                    <h1>
                       
                        <span className="ffpf-hero-accent">
                            Faux Fur Pom Poms
                        </span>
                    </h1>


                 
                </div>

                <div className="ffpf-hero-wave" aria-hidden="true">
                    <svg
                        viewBox="0 0 1440 64"
                        preserveAspectRatio="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0,32 C240,64 480,0 720,32 C960,64 1200,0 1440,32 L1440,64 L0,64 Z"
                            fill="#f8f7fc"
                        />
                    </svg>
                </div>
            </section>

            {/* Mobile filter tabs */}
            <div
                className="ffpf-mobile-filters"
                role="navigation"
                aria-label="Filter by category"
            >
                <div className="ffpf-mobile-filters-inner">

                  

                </div>
            </div>

            

        </div>
    );
};

export default FauxFurPomPomsPage;